import React from 'react'
import { Tooltip as AntdTooltip, TooltipProps } from 'antd'
import { Global, css } from '@emotion/react'

export const Tooltip: React.FC<TooltipProps> = props => {
  return (
    <>
      <Global
        styles={css`
          .ant-tooltip-inner {
            a {
              color: #fff;
              text-decoration: underline;
            }
          }
        `}
      />
      <AntdTooltip {...props} />
    </>
  )
}

type ConditionalToolTip = TooltipProps & { showTooltip: boolean }

export const ConditionalToolTip: React.FC<ConditionalToolTip> = props => {
  const [visible, setVisible] = React.useState(false)
  const { showTooltip, children, ...toolTipProps } = props

  return (
    <Tooltip
      {...toolTipProps}
      open={visible}
      onOpenChange={nextVisible => {
        showTooltip ? setVisible(nextVisible) : setVisible(false)
      }}
    >
      {children}
    </Tooltip>
  )
}
